"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getCurrencySymbol = (inputLocale, inputCurrencyCode) => (0)
    .toLocaleString(inputLocale, {
    style: 'currency',
    currency: inputCurrencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})
    .replace(/\d/g, '')
    .trim();
exports.default = getCurrencySymbol;
